import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SegmentedTabs from 'shared/components/ui/SegmentedTabs';
import Icon from 'shared/components/Icon';
import { useBreadcrumbActions } from 'shared/context/BreadcrumbContext';

/**
 * Failures | Issues switcher in the top bar, like the Traces grain switcher.
 * Failures are what happened, grouped by rule; issues are what someone (a
 * person, an eval, or Ask) decided is a problem worth tracking.
 *
 * Failures comes first and is where you land: every team has failures, not
 * every team has issues. `?tab=issues` picks Issues, and so does a link to one
 * issue (`?issue=<id>`), which opens it in the drawer over the list.
 */
const VIEWS = [
  {
    value: 'failures',
    label: 'Failures',
    hint: 'Hard failures grouped by agent, tool and error',
    icon: ({ size }) => <Icon name="span" size={size} color="currentColor" />,
  },
  {
    value: 'issues',
    label: 'Issues',
    hint: 'Problems being tracked, with root cause and evidence',
    icon: ({ size }) => <Icon name="issues" size={size} color="currentColor" />,
  },
];

export function issuesViewFrom(searchParams) {
  return searchParams.get('tab') === 'issues' || searchParams.get('issue') ? 'issues' : 'failures';
}

const IssuesViewTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = issuesViewFrom(searchParams);

  useBreadcrumbActions(
    <SegmentedTabs
      options={VIEWS}
      value={value}
      size="sm"
      ariaLabel="Issues view"
      onChange={(next) => {
        const qs = new URLSearchParams();
        if (next === 'issues') qs.set('tab', 'issues');
        setSearchParams(qs);
      }}
    />
  );

  return null;
};

export default IssuesViewTabs;
